import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
export const EdgeType = {
  STANDARD: 'STANDARD',
  PASS_THROUGH: 'PASS_THROUGH',
  GOTO: 'GOTO'
};
/**
 * Dry representation of a DirectedNodes graph's edges.
 * These records should only ever describe information
 * regarding the connectivity rendering logic of the
 * graph.
 */
export default class Edge extends createImmutableObjectClass({
  edgeId: null,
  edgeType: EdgeType.STANDARD,
  fromNode: null,
  toNode: null,
  showAddControl: false,
  isLoopEdge: false,
  isLoopReturnEdge: false
}) {
  getId() {
    return this.edgeId;
  }
  getFromNode() {
    return this.fromNode;
  }
  getToNode() {
    return this.toNode;
  }
  getShouldShowAddControl() {
    return this.showAddControl;
  }
  getIsLoopEdge() {
    return this.isLoopEdge;
  }
  getIsLoopReturnEdge() {
    return this.isLoopReturnEdge;
  }
  isGoToEdge() {
    return this.edgeType === EdgeType.GOTO;
  }
}